// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Profile from './Profile';
import MobileSection from './MobileSection';
import { Box } from '@mui/material';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ ml: 'auto' }}>
        {!downLG && <Profile />}
        {downLG && <MobileSection />}
      </Box>
    </Box>
    </>
  );
}
